/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Localcms_Resources_Search_PlaceholderInputs */

const en_localcms_resources_search_placeholder = /** @type {(inputs: Localcms_Resources_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search articles, FAQs`)
};

/**
* | output |
* | --- |
* | "Search articles, FAQs" |
*
* @param {Localcms_Resources_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const localcms_resources_search_placeholder = /** @type {((inputs?: Localcms_Resources_Search_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Localcms_Resources_Search_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_localcms_resources_search_placeholder(inputs)
});